import { render, staticRenderFns } from "./Experts.vue?vue&type=template&id=0965b28b&"
import script from "./Experts.vue?vue&type=script&lang=js&"
export * from "./Experts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports